import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesEnum } from 'src/app/constants/RoutesEnum';

@Injectable({
	providedIn: 'root',
})
export class NavigationService {
	constructor(private router: Router) {}

	public goToHome() { 
		const userRole = sessionStorage.getItem('rol');
		 if (userRole === 'Admin') {
			this.router.navigate(['./mis-equipos']); // home maps
		} else if (userRole === 'AdminEmpresa') {
			this.router.navigate(['./mis-equipos']); // puede que en un futuro tenga home propia
		} 
		else if (userRole === 'Soporte') {
			this.router.navigate(['./mantenimiento']); 
		} else if (userRole === 'Visor') {
			this.router.navigate(['./mis-equipos']); // por el momento a el mapa capaz luego tenga su propia pagina
		} else {
			this.router.navigate(['./mis-equipos']); // por defecto ante la nada
		}
	}

	public goToAuth() {
		this.router.navigate(['/authentication/login']);
	}

	public goNotAuthorized() {
		this.router.navigate(['/authentication/notAuthorized']);
	}

	public goToMisDatos() {
		this.router.navigate(['/usuarios/mi-perfil']);
	}

	public goToPerfilEmpresa(id: number)  {
		this.router.navigate(['/empresas/perfil/' + id]);
	}

	public goToUsuarios() {
		this.router.navigate(['/usuarios']);
	}

	public goToUsuario(id: number) {
		this.router.navigate(['/usuarios/editar/' + id]);
	}

	public goToEmpresas() {
		this.router.navigate(['/empresas']);
	}

	public goToEmpresa(id: number) {
		this.router.navigate(['/empresas/editar/' + id]);
	}

	public goToEvento(id: number, idMaquina: number, idTipo: number) {
		this.router.navigate(['/equipos/eventos/editar/' + id + '/' + idMaquina + '/' + idTipo]);
	}

	public goToEventos() {
		this.router.navigate(['/equipos/eventos']);
	}

	public goToEventos_(idMaquina:number) {
		this.router.navigate(['/equipos/eventos/' + idMaquina]);
	}

	public goToMantenimientos() {
		this.router.navigate([`/${RoutesEnum.Maintenance}`]);
	}

	public goToMantenimiento(id: number) {
		this.router.navigate([`/${RoutesEnum.Maintenance}/editar/` + id]);
	}

	gotoRaven(): void {
		window.open('https://portal.ravenslingshot.com/index.php?r=site/login', '_blank');
	}
}
